import { render, staticRenderFns } from "./SalesChannelPromotionsTable.vue?vue&type=template&id=2dd49678&"
import script from "./SalesChannelPromotionsTable.vue?vue&type=script&lang=js&"
export * from "./SalesChannelPromotionsTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesChannelPromotionsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports